import { Component, OnInit, Input } from '@angular/core';
import { ModalController, RadioGroupChangeEventDetail } from '@ionic/angular';

@Component({
  selector: 'app-modal-sort',
  templateUrl: './modal-sort.component.html',
  styleUrls: ['./modal-sort.component.scss'],
})
export class ModalSortComponent implements OnInit {
  @Input() options: string[];
  modalValue: string;

  constructor(private modalController: ModalController) {}

  ngOnInit() {}

  radioGroupChange(event: Event) {
    const customEvent = event as CustomEvent<RadioGroupChangeEventDetail>;
    this.modalValue = customEvent.detail.value;
  }

  submitHandler() {
    this.modalController.dismiss({ value: this.modalValue }, 'confirm');
  }

  cancel() {
    this.modalController.dismiss(null, 'cancel');
  }
}
